import { Injectable } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { InicialPage } from '../pages/inicial/inicial';
import { FoneCpfPage } from '../pages/fonecpf/fonecpf';
import { DenunciaListaPage } from '../pages/denuncialista/denuncialista';
import { DenunciaRegistroPage } from '../pages/denunciaregistro/denunciaregistro';
import { DenunciaDetalhesPage } from '../pages/denunciadetalhes/denunciadetalhes';
import { NavegadorPage } from '../pages/navegador/navegador';
import { ConversaPageWatson } from '../pages/conversaWatson/conversa';
import {ImagemGedPage} from '../pages/imagem-ged/imagem-ged'
import { LoginWebPage } from '../pages/login-web/login-web';
import { NavProxyProvider } from '../providers/nav-proxy/nav-proxy';

var instanceIniciaPaginaService: IniciaPaginaService;

@Injectable()
export class IniciaPaginaService {

    private navCtrl: NavController;

    constructor(public events: Events,     private navProxyProvider: NavProxyProvider) {
        instanceIniciaPaginaService = this;
    }

    init() {
        let events = instanceIniciaPaginaService.events;

        events.subscribe("iniciapagina:root:LoginWeb", () => {
            //this.navProxyProvider.pushMainPageLogin();
            instanceIniciaPaginaService.navCtrl.setRoot(LoginWebPage);
        });
        events.subscribe("iniciapagina:init", (nav) => {
            instanceIniciaPaginaService.navCtrl = nav;
        });
        events.subscribe("iniciapagina:root:Inicial", () => {
            instanceIniciaPaginaService.navCtrl.setRoot(InicialPage, {});
        });
        events.subscribe("iniciapagina:root:FoneCpf", () => {
            instanceIniciaPaginaService.navCtrl.setRoot(FoneCpfPage, {});
        });
        events.subscribe("iniciapagina:push:ConversaWatson", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(ConversaPageWatson, params)
        });
        events.subscribe("iniciapagina:push:DenunciaLista", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(DenunciaListaPage, params);
        });
        events.subscribe("iniciapagina:push:DenunciaRegistro", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(DenunciaRegistroPage, params);
        });
        events.subscribe("iniciapagina:push:DenunciaDetalhes", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(DenunciaDetalhesPage, params);
        });
        events.subscribe("iniciapagina:push:Navegador", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(NavegadorPage, params);
        });
        events.subscribe("iniciapagina:push:ImagemGED", (params: any) => {
            instanceIniciaPaginaService.navCtrl.push(ImagemGedPage, params)
        })
        events.subscribe("marcaNaoLidaSeNaoEstiverEmRotinaLeitura", (params: any) => {
            let cp = instanceIniciaPaginaService.navCtrl.getActive();

            console.log(cp);
            console.log(cp.name);
            console.log(JSON.stringify(cp.getNavParams()));
            console.log(JSON.stringify(params));
            var emPaginaLeitura = false;
            if (cp && cp.name && cp.name=='ConversaPage' && cp.getNavParams() && cp.getNavParams().data && cp.getNavParams().data.codEmpresa && cp.getNavParams().data.codEmpresa==params.codEmpresa) {
                emPaginaLeitura = true;
            }
            if (!emPaginaLeitura) {
                instanceIniciaPaginaService.events.publish("marcaNaoLidoEfetivo", {codEmpresa:params.codEmpresa, marca:true});
            }
        });
        events.subscribe("iniciapagina:l:iniciaPaginaConversaPorCodEmpresa", (params: any) => {
            let cp = instanceIniciaPaginaService.navCtrl.getActive();
            console.log(cp);
            console.log(cp.name);
            console.log(JSON.stringify(cp.getNavParams()));
            var valido = false;
            if (!cp)
                valido = true;
            else {
                let pageParams = cp.getNavParams();
                if (!pageParams || !pageParams.data || cp.name != 'ConversaPage')
                    valido = true;
                else {
                    if (pageParams.data.codEmpresa != params.codEmpresa)
                        valido = true;
                }
            }
            if (!valido) {
                console.log('Click invalido');
                return;
            }
            instanceIniciaPaginaService.events.publish("iniciapagina:push:Conversa", { codEmpresa: params.codEmpresa, codUsuario: params.codUsuario });
        });
    }

}


// WEBPACK FOOTER //
// ./src/service/IniciaPaginaService.ts